import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ExpressEntry.css";
import { FaRupeeSign } from "react-icons/fa";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import BASE_URL from "../Config";

const ExpressEntry = () => {
  const initialValues = {
    deletegate_category: "",
    dName: "",
    ddesignation: "",
    demail: "",
    ddial_code: "91",
    dmobile: "",
    organization_name: "",
    GSTIN: "",
    delegateFee: "",
    tax: "",
    refNumber: "",
    payment_mode: "",
    url_for_qr: "",
    amount: "",
    tax: "",
    total_amount: "",
  };

  const [initialFormData, setInitialFormData] = useState(initialValues);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchSingleRegistration = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/getSingleSpotRegistration`,
        { id }
      );

      const data = response.data?.data?.[0];
      if (data) {
        setInitialFormData((prev) => ({
          ...prev,
          dName: data.name || "",
          dmobile: data.mobile || "",
          ddial_code: data.dial_code?.replace("+", "") || "91",
          demail: data.email || "",
          ddesignation: data.designation || "",
          organization_name: data.organization_name || "",
          GSTIN: data.GSTIN || "",
          deletegate_category: data.deletegate_category || "Delegate",
          refNumber: data.id || "",
          delegateFee: data.amount || "",
          payment_mode: data.payment_mode || "",
          url_for_qr: data.url_for_qr_code || "",
          amount: data.amount || "",
          tax: data.tax || "",
          total_amount: data.total_amount || "",
        }));
      }
    } catch (error) {
      console.error("Error fetching registration data:", error);
    }
  };

  useEffect(() => {
    if (id) fetchSingleRegistration();
  }, [id]);

  const validationSchema = Yup.object().shape({
    dName: Yup.string().required("Name is required"),
    dmobile: Yup.string()
      .matches(/^[0-9]{10,15}$/, "Invalid mobile number")
      .required("Mobile number is required"),
    demail: Yup.string().email("Invalid email").required("Email is required"),
    organization_name: Yup.string(),
    payment_mode: Yup.string().required("Please choose a payment mode"), // ⬅️ required
    GSTIN: Yup.string()
      .nullable()
      .when("organization_name", {
        is: (orgName) => orgName && orgName.trim() !== "",
        then: (schema) =>
          schema
            .notRequired("GSTIN is required")
            .matches(
              /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{3}$/,
              "Invalid GSTIN format"
            ),
      }),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        name: values.dName,
        event_id: id,
        id: id,
        mobile: values.dmobile,
        dial_code: values.ddial_code,
        email: values.demail,
        designation: values.ddesignation,
        organization_name: values.organization_name,
        GSTIN: values.GSTIN,
        deletegate_category: values.deletegate_category,
        payment_mode: values.payment_mode,
        url_for_qr: `https://event.sopa.org/delegate/${id}/0`,
        amount:
          values.payment_mode === "Free" ? 0 : initialFormData?.amount || "",
        tax: values.payment_mode === "Free" ? 0 : initialFormData?.tax || "",
        total_amount:
          values.payment_mode === "Free"
            ? 0
            : initialFormData?.total_amount || "",
      };

      const response = await axios.post(
        `${BASE_URL}/updateSpotRegistration`,
        payload
      );

      // setShowSuccessPopup(true);
      navigate(`/express-entry-print/${id}`);

      resetForm();
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Registration failed!");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="card">
      <div className="card-body">
        <h2
          style={{
            color: "black",
            fontWeight: "700",
            fontSize: "2rem",
            marginBottom: "5px",
          }}
        >
          EXPRESS ENTRY
        </h2>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >
          <button
            onClick={() => navigate(-1)}
            style={{
              backgroundColor: "#4696A0",
              color: "white",
              border: "none",
              borderRadius: "20px",
              padding: "8px 20px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Go Back
          </button>

          <button
            onClick={() => {
              // Clear session storage, local storage, or cookies as needed
              localStorage.clear();
              sessionStorage.clear();

              // Redirect to /breakfast-scanner
              navigate("/admin/login");
            }}
            style={{
              backgroundColor: "#4696A0",
              color: "white",
              border: "none",
              borderRadius: "20px",
              padding: "8px 20px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Logout
          </button>
        </div>

        <Formik
          enableReinitialize
          initialValues={initialFormData}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <fieldset id="step1">
                <div className="form-card clearfix">
                  {/* Fee Summary */}
                  <div className="package-item d-flex justify-content-between align-items-center mb-4">
                    <h3 className="package-title font-bold">
                      Reff. No. #{initialFormData.refNumber}
                    </h3>
                    <h3 className="package-title font-bold">
                      Delegate Fee ₹{initialFormData.total_amount}
                    </h3>
                  </div>

                  {/* Delegate Type */}
                  <h2 className="package-title company font-bold">
                    Deletegate Type
                  </h2>
                  <div className="row mb-3">
                    <div className="form-group mb-3 col-md-6">
                      <Field
                        as="select"
                        name="deletegate_category"
                        className="form-control"
                      >
                        <option value="Delegate">Delegate</option>
                      </Field>
                    </div>
                  </div>

                  {/* Delegate Info */}
                  <h2 className="package-title font-bold">
                    Delegates Information
                  </h2>
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label>Name</label>
                      <Field
                        name="dName"
                        className="form-control"
                        placeholder="Enter a Name"
                      />
                      <ErrorMessage
                        name="dName"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Designation</label>
                      <Field
                        name="ddesignation"
                        className="form-control"
                        placeholder="Enter Designation"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Email</label>
                      <Field
                        name="demail"
                        type="email"
                        className="form-control"
                        placeholder="Enter Email"
                      />
                      <ErrorMessage
                        name="demail"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Mobile No.</label>
                      <div className="input-group">
                        <Field as="select" name="ddial_code" className="px-3">
                          <option value="91">91</option>
                        </Field>
                        <Field
                          name="dmobile"
                          className="form-control"
                          placeholder="Enter Mobile No."
                        />
                      </div>
                      <ErrorMessage
                        name="dmobile"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                  </div>

                  {/* Company Info */}
                  <h2 className="package-title company font-bold">
                    Company Information
                  </h2>
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label>Organization Name</label>
                      <Field
                        name="organization_name"
                        className="form-control"
                        placeholder="Organization Name"
                      />
                      <ErrorMessage
                        name="organization_name"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>GSTIN</label>
                      <Field name="GSTIN">
                        {({ field, form }) => (
                          <input
                            {...field}
                            type="text"
                            className="form-control"
                            placeholder="GSTIN"
                            style={{ textTransform: "uppercase" }}
                            onChange={(e) => {
                              const value = e.target.value.toUpperCase();
                              form.setFieldValue("GSTIN", value);
                            }}
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="GSTIN"
                        className="text-danger"
                        component="div"
                      />
                    </div>
                  </div>

                  {/* Payment Information */}
                  <h2 className="package-title company font-bold mt-4">
                    Payment Information
                  </h2>
                  <div
                    className="row mb-3 p-3"
                    style={{ backgroundColor: "#f3fcff", borderRadius: "8px" }}
                  >
                    <div
                      className="row mb-3 p-3"
                      style={{
                        backgroundColor: "#f3fcff",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="form-group mb-0 col-md-12 d-flex align-items-center flex-wrap">
                        <label
                          className="me-3 mb-0"
                          style={{ fontWeight: "500", color: "#1B1B1D" }}
                        >
                          Payment Mode <span style={{ color: "red" }}>*</span>
                        </label>

                        <div className="form-check me-5">
                          <Field
                            type="radio"
                            name="payment_mode"
                            value="Upi"
                            className="form-check-input custom-radio"
                            id="upi"
                          />
                          <label className="form-check-label" htmlFor="upi">
                            Upi
                          </label>
                        </div>

                        <div className="form-check me-4">
                          <Field
                            type="radio"
                            name="payment_mode"
                            value="Card"
                            className="form-check-input custom-radio"
                            id="card"
                          />
                          <label className="form-check-label" htmlFor="card">
                            Card
                          </label>
                        </div>

                        <div className="form-check me-4">
                          <Field
                            type="radio"
                            name="payment_mode"
                            value="Cash"
                            className="form-check-input custom-radio"
                            id="cash"
                          />
                          <label className="form-check-label" htmlFor="cash">
                            Cash
                          </label>
                        </div>

                        <div className="form-check">
                          <Field
                            type="radio"
                            name="payment_mode"
                            value="Free"
                            className="form-check-input custom-radio"
                            id="free"
                          />
                          <label className="form-check-label" htmlFor="free">
                            Free
                          </label>
                        </div>

                        <div className="w-100 mt-1">
                          <ErrorMessage
                            name="payment_mode"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="btn btn-md btn-primary tra-black-hover submit"
                    style={{
                      fontSize: "14px",
                      fontWeight: 600,
                      background: "#F8C400",
                      border: "0",
                      color: "#1B1B1D",
                      borderRadius: "50px",
                      padding: "8px 20px",
                      marginTop: "20px",
                      float: "right",
                      height: "37px",
                    }}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </fieldset>
            </Form>
          )}
        </Formik>
      </div>
      {/* {showSuccessPopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "30px 40px",
              borderRadius: "8px",
              boxShadow: "0 0 10px rgba(0,0,0,0.2)",
              textAlign: "center",
              maxWidth: "400px",
            }}
          >
            <h4 style={{ marginBottom: "20px" }}>
              Registration updated successfully!
            </h4>
            <button
              onClick={() => navigate(`/express-entry-print/${id}`)}
              style={{
                padding: "8px 20px",
                backgroundColor: "#4696A0",
                color: "white",
                border: "none",
                borderRadius: "20px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default ExpressEntry;
